module.exports = __webpack_public_path__ + "static/icons/icon-resort-guide-421ed2230fc460b3b3740dbbeb0c060a.svg";